import type { DfmFinding } from './types'

/**
 * UID-151 (E1) — maps the wire contract's `DfmSummary.findings: string[]`
 * (`schema.gen.ts`; today's frozen contract, no `DfmFinding` schema exists —
 * see Story E0, deferred) onto the FE render shape `DfmFinding[]`
 * (`types.ts`). Every mapped finding gets the neutral `'info'` severity —
 * this is a rendering default, not data the contract provides; do not
 * upgrade a finding to `'flag'`/`'pass'` here without a corresponding
 * contract field to justify it.
 */
export function toDfmFindings(findings: readonly string[] | undefined): readonly DfmFinding[] {
  return (findings ?? []).map((label) => ({ severity: 'info' as const, label }))
}

/** Text label always shown alongside the severity indicator (WCAG 1.4.1 —
 * color is never the only signal). Neutral by design: `pass`/`flag` are
 * reserved for a future enriched contract (Story E0). */
export const DFM_SEVERITY_LABEL: Record<DfmFinding['severity'], string> = {
  pass: 'Pass',
  flag: 'Flag',
  info: 'Discrepancy',
}
